<template>
	<div>
		<el-card>
			<el-table :data="data.admins"  style="width: 100%;text-align: center;" size="mini">
				<el-table-column align="center" header-align="center" label="编号" width="100">
					<template slot-scope="scope">
						{{scope.$index + 1}}
					</template>
				</el-table-column>
				<el-table-column align="center" header-align="center" prop="admin_name" label="姓名">
				</el-table-column>
				<el-table-column align="center" header-align="center" prop="admin_tel" label="手机号">
				</el-table-column>
				<el-table-column align="center" header-align="center" prop="admin_postion" label="职位">
				</el-table-column>
				<el-table-column align="center" header-align="center" prop="" label="添加日期">
					<template slot-scope="scope">
						{{timeFormat(scope.row.admin_adddate,'yyyy-mm-dd hh:MM:ss')}}
						<!-- <el-button size="mini" type="danger" @click="deleteStore(scope.$index, scope.row)">取消认证</el-button> -->
					</template>
				</el-table-column>
				<el-table-column align="center" header-align="center" prop="" label="日期">
					<template slot-scope="scope">
						<el-button size="mini" type="danger" @click="deleteAdmin(scope.$index, scope.row)">删除</el-button>
					</template>
				</el-table-column>
			
			</el-table>
			<div style="display: flex;justify-content: flex-end; ">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="form.page"
				 :page-sizes="[10, 20, 50, 100]" :page-size="form.limit" layout="total, sizes, prev, pager, next, jumper"
				 :total="data.total">
				</el-pagination>
			</div>
		</el-card>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				form: {
					page: 1,
					limit: 10,
				},
				data: []
			}
		},
		mounted() {
			this.getData();
		},
		methods: {
			toArray(str) {
				var arry = str.split(",");
				console.log(arry);
				return arry;
			},
			handleSizeChange(e) {
				this.form.limit = e;
				this.getData();
			},
			handleCurrentChange(e) {
				this.form.page = e;
				this.getData();
			},
			deleteAdmin(index, row) {
				var that = this;
				this.$confirm('确定要删除吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '考虑以下',
					type: 'warning'
				}).then(() => {
					that.$axios.post('zuche/admin/deleteAdmin', {admin_id:row.admin_id}).then(function(res) {
						console.log(res);
						if (res.data.success) {
							that.getData();
						} else {
							that.$message.error(res.data.message);
						}
					});
				})
			},
			getData() {
				var that = this;
				this.$axios.post('zuche/admin/getAdminList', this.form).then(function(res) {
					console.log(res);
					if (res.data.success) {
						that.data = res.data.result;
					} else {
						that.$message.error(res.data.message);
					}
				});
			}
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/zhanghaoguanli.vue